module.exports = __webpack_public_path__ + "img/super-bundle-14.108b2d5.webp";